import React from "react";
import Header from "../components/Header";
import { pageColors } from "../mock";

const AppPage = () => {
  React.useEffect(() => {
    document.title = "TMM|APP";
  }, []);

  return (
    <>
      <Header hoverColor={pageColors.app} compact={false} />
      <div className="sc-subpage">
        <div className="sc-box-app">
          <img
            src="/img/_app_download.png"
            className="sub-img"
            alt="app download graphic"
          />
        </div>
      </div>
    </>
  );
};

export default AppPage;
